import script from "./leftline2.vue?vue&type=script&setup=true&lang=js"
export * from "./leftline2.vue?vue&type=script&setup=true&lang=js"

import "./leftline2.vue?vue&type=style&index=0&id=28100824&scoped=true&lang=css"
script.__scopeId = "data-v-28100824"

export default script